import React, { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import { DecisionSwal } from "Utils/Utils/DecisionSwal";
import { getErrorFromResponse } from "../../../../../../../../utility/utils";
import { ProduccionV2Api } from "../../../../../ProduccionV2/api/ProduccionV2Api";
import { RecepcionIngresoApi } from "../api/RecepcionIngresoApi";

export const useDetallePaletizacion = (idPaletizacion, regresar) => {
    const {
        getDetallePaletizacion,

        cargando,
    } = ProduccionV2Api();

    const { guardarEstadoRecepcion, cargando: cargandoGuardado } =
        RecepcionIngresoApi();

    const [pallets, setPallets] = useState([]);
    const [metricasPaletizacion, setMetricasPaletizacion] = useState({});

    const GetDetallePaletizacion = async (idPaletizacion) => {
        try {
            const response =
                (await getDetallePaletizacion(idPaletizacion)) || {};
            setPallets(response.pallets || []);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener los pallets de la paletización",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
            setPallets([]);
        }
    };

    useEffect(() => {
        if (idPaletizacion) {
            GetDetallePaletizacion(idPaletizacion);
        }
    }, [idPaletizacion]);

    const GuardarEstadoRecepcion = async () => {
        try {
            const data = {
                paletizacion_id: idPaletizacion,
                pallets: pallets.map((pallet) => ({
                    id: pallet.id,
                    recibido_bodega: pallet.recibido_bodega,
                })),
            };
            await guardarEstadoRecepcion(data);
            NotificationManager.success(
                "Estado de recepción guardado exitosamente",
                "Éxito",
                3000,
            );
            regresar();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al guardar el estado de recepción",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    // los pallets sin marcar quedan rechazados y la recepción ya no puede
    // modificarse, por lo que se confirma cuando no se reciben todos
    const ConfirmarEstadoRecepcion = () => {
        const totalRecibidos = pallets.filter(
            (pallet) => pallet.recibido_bodega,
        ).length;

        if (totalRecibidos === pallets.length) {
            GuardarEstadoRecepcion();
            return;
        }

        let mensaje = "No se recibirá ningún pallet de la paletización";
        if (totalRecibidos > 0) {
            const verbo = totalRecibidos === 1 ? "Se recibirá" : "Se recibirán";
            mensaje = `${verbo} ${totalRecibidos} de ${pallets.length} pallets. `;
            mensaje += "Los pallets no seleccionados se registrarán como rechazados";
        }
        mensaje += " y la recepción no podrá modificarse. ¿Desea continuar?";

        DecisionSwal(
            mensaje,
            totalRecibidos > 0 ? "Sí, aceptar" : "Sí, rechazar",
            "Cancelar",
            GuardarEstadoRecepcion,
        );
    };

    return {
        pallets,
        setPallets,
        ConfirmarEstadoRecepcion,

        cargando: cargando || cargandoGuardado,
    };
};
